import { Directive, Injector, Input } from '@angular/core';

import { ApAlertService, ApComplexModal, ApNotificationService } from 'webcommon/core-ui';
import { EventComposite, GuidStrValue, PermissionNames, VisibleToEnum } from 'webcommon/shared';

import { EMPTY, of } from 'rxjs';
import { PermissionRepository } from 'webcommon/webapi';
import { FilterChangedResult, FilterChangedStatus, FilterData, FilterTypeDataMap } from '../FilterTypeData';
import { FcFilterSaveAsModalService } from '../../fc-filter/medication-filter/fc-filter-save-as-modal.service';
import { FormControl, FormGroup } from '@angular/forms';
import { FilterCommonFormControls, FilterSubmitType } from '../../models/FilterFormControls';

@Directive()
export abstract class FcFilterTypeModalBaseComponent
<K extends keyof FilterTypeDataMap = keyof FilterTypeDataMap> extends ApComplexModal<FilterChangedResult> {
  protected readonly apNotificationService: ApNotificationService;
  protected readonly alertService: ApAlertService;
  protected readonly permissionRepository: PermissionRepository;
  protected readonly fcSaveAsModalService: FcFilterSaveAsModalService;

  @Input() patientId?: GuidStrValue;
  filterData: FilterData<K>;
  hideDefault = false;

  filterSubmitType = FilterSubmitType;
  submitType: FilterSubmitType = this.filterSubmitType.Apply; // Default

  isLoading = false;
  isSaving = false;

  commonFilterForm = new FormGroup<FilterCommonFormControls>({
    makeMyDefault: new FormControl<boolean>(false, { nonNullable: true }),
    visibleTo: new FormControl<VisibleToEnum>(VisibleToEnum.Everyone, { nonNullable: true }),
  });

  constructor(
    injector: Injector,
  ) {
    super(injector);
    this.apNotificationService = injector.get(ApNotificationService);
    this.alertService = injector.get(ApAlertService);
    this.permissionRepository = injector.get(PermissionRepository);
    this.fcSaveAsModalService = injector.get(FcFilterSaveAsModalService);
  }

  filterPermission$ = new EventComposite(this, (permissionName: PermissionNames | null) => {
    if (!!permissionName) {
      return this.permissionRepository.getSecurityPermissions(permissionName);
    } else {
      return of(null);
    }
  }).start(null);

  applyFilterClickDone(result: FilterData<K>) {
    this.onClose(FilterChangedStatus.DynamicFilter, result);
  }

  saveFilterClickDone(result: FilterData<K>) {
    this.onClose(FilterChangedStatus.FilterSelected, result);
  }

  saveAsFilterClickDone(result: FilterData<K>) {
    this.onClose(FilterChangedStatus.FilterSelected, result);
  }

  saveAsFilterModal() {
    return this.fcSaveAsModalService.openModal();
  }

  cancelFilterClick() {
    this.apUserCancel();
    return EMPTY;
  };

  onClose(status: FilterChangedStatus, result: FilterData<K>) {
    /*
      If filter is saved we should only be using FilterData.filterId and FilterChangedStatus.FilterSelected
      IF filter is unsaved we should be using FilterData.data and FilterChangedStatus.DynamicFilter
    */
    const changedResult = {
      filterChangedStatus: status,
      filterData: result,

    };
    this.apClose(changedResult);
  }
}
